"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NearsMissingNoteAbilityHandler = exports.NearsMissingNoteActorAbilityFactory = exports.NearsMissingNoteAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const core_1 = require("../../core/effects/core");
const Duration_1 = require("../../core/Duration");
const AbilityDamage_1 = require("../../core/AbilityDamage");
class NearsMissingNoteAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.NearsMissingNote;
        this.__typeName = "NearsMissingNote";
    }
}
exports.NearsMissingNoteAbilityArgs = NearsMissingNoteAbilityArgs;
let NearsMissingNoteActorAbilityFactory = class NearsMissingNoteActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("NearsMissingNote", "OneEnemies", 3);
    }
};
NearsMissingNoteActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("NearsMissingNote")
], NearsMissingNoteActorAbilityFactory);
exports.NearsMissingNoteActorAbilityFactory = NearsMissingNoteActorAbilityFactory;
let NearsMissingNoteAbilityHandler = class NearsMissingNoteAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const [selectedEnemy] = ability.args.target.actorIds;
        container.applyAttackWithDamage({
            sequence,
            abilityKey: ability.args.__typeName,
            attackType: "magic",
            attackerId: ability.invokerId,
            targetId: selectedEnemy,
            toApply: [
                AbilityDamage_1.AbilityDamage.Focus("Sonic", 150)
            ],
            onHit: (sequence) => {
                container.applyDebuff({
                    sequence,
                    attackerId: ability.invokerId,
                    targetId: selectedEnemy,
                    duration: Duration_1.Duration.Permanent,
                    effect: new core_1.DizzyEffectArgs(1),
                });
            }
        });
    }
};
NearsMissingNoteAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.NearsMissingNote)
], NearsMissingNoteAbilityHandler);
exports.NearsMissingNoteAbilityHandler = NearsMissingNoteAbilityHandler;
